export default __webpack_public_path__ + "static/0191-fe03212d46f3434388e7f803c0a681ce.png";